import { useTranslation } from 'react-i18next';
import { MyBenefitsTabTypes } from '../types';
import { resources } from '../../../resources/resources';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { useContext } from 'react';

interface MyBenefitsTabNavProps {
  activeTab: MyBenefitsTabTypes;
  onTabChange: (tab: MyBenefitsTabTypes) => void;
}

export default function MyBenefitsTabNav(
  props: Readonly<MyBenefitsTabNavProps>,
) {
  const { customerInfo } = useContext(CustomerInfoContext);
  const { activeTab, onTabChange } = props;
  const { t: translate } = useTranslation();
  return (
    <ul className="acc-tabs">
      {customerInfo.canAccessSubscriptions && (
        <li
          onClick={() => onTabChange(MyBenefitsTabTypes.Subscriptions)}
          className={
            activeTab === MyBenefitsTabTypes.Subscriptions
              ? 'acc-tab-active'
              : undefined
          }
        >
          {translate(resources.myBenefitsPage.tabs.recurringBenefits)}
        </li>
      )}
      {customerInfo.canAccessMyBenefits && (
        <li
          onClick={() => onTabChange(MyBenefitsTabTypes.FixedBenefits)}
          className={
            activeTab === MyBenefitsTabTypes.FixedBenefits
              ? 'acc-tab-active'
              : undefined
          }
        >
          {translate(resources.myBenefitsPage.tabs.fixedBenefits)}
        </li>
      )}
      {customerInfo.canAccessExclusive && (
        <li
          onClick={() => onTabChange(MyBenefitsTabTypes.ExclusiveBenefits)}
          className={
            activeTab === MyBenefitsTabTypes.ExclusiveBenefits
              ? 'acc-tab-active'
              : undefined
          }
        >
          {translate(resources.myBenefitsPage.tabs.exclusiveBenefits)}
        </li>
      )}
    </ul>
  );
}
